<template>
  <router-link
    :to="{
      name: 'market-details',
      params: { marketId: promo.marketId, marketUrl: promo.marketUrl },
    }"
    custom
    v-slot="{ navigate }"
  >
    <div class="market-biggest-gains-element" @click="navigate">
      <div v-if="header" class="market-biggest-gains-element__header">
        {{ promo.sectionTitle }}
      </div>
      <div class="market-biggest-gains-element__content">
        <div class="market-biggest-gains-element__market">
          {{ promo.marketName }}
        </div>
        <div class="market-biggest-gains-element__wrapper">
          <div class="market-biggest-gains-element__contract">
            {{ promo.contractName }}
          </div>
          <div>
            <span class="market-biggest-gains-element__current-price">
              <template v-if="hasLastTradePrice">
                <animated-number :value="contract.lastTradePriceAsCents"></animated-number>
              </template>
              <template v-else> -<span v-html="'&cent;'"></span> </template>
            </span>
            <market-change-price
              :price="contract.changePriceAsCents"
              :lastClosePrice="contract.lastClosePrice"
            >
            </market-change-price>
          </div>
          <div v-if="hasLastTradePrice" :class="iconModifiers"></div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script src="./market-biggest-gains-element.js"></script>
<style src="./market-biggest-gains-element.scss" lang="scss"></style>
